import { render, staticRenderFns } from "./UserCardInfo.vue?vue&type=template&id=2f0abbf8&"
import script from "./UserCardInfo.vue?vue&type=script&lang=js&"
export * from "./UserCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports